const states = [
  ["acre", "AC", "Acre"], ["alagoas", "AL", "Alagoas"], ["amapa", "AP", "Amapá"], ["amazonas", "AM", "Amazonas"],
  ["bahia", "BA", "Bahia"], ["ceara", "CE", "Ceará"], ["distrito-federal", "DF", "Distrito Federal"],
  ["espirito-santo", "ES", "Espírito Santo"], ["goias", "GO", "Goiás"], ["maranhao", "MA", "Maranhão"],
  ["mato-grosso", "MT", "Mato Grosso"], ["mato-grosso-do-sul", "MS", "Mato Grosso do Sul"],
  ["minas-gerais", "MG", "Minas Gerais"], ["para", "PA", "Pará"], ["paraiba", "PB", "Paraíba"],
  ["parana", "PR", "Paraná"], ["pernambuco", "PE", "Pernambuco"], ["piaui", "PI", "Piauí"],
  ["rio-de-janeiro", "RJ", "Rio de Janeiro"], ["rio-grande-do-norte", "RN", "Rio Grande do Norte"],
  ["rio-grande-do-sul", "RS", "Rio Grande do Sul"], ["rondonia", "RO", "Rondônia"], ["roraima", "RR", "Roraima"],
  ["santa-catarina", "SC", "Santa Catarina"], ["sao-paulo", "SP", "São Paulo"], ["sergipe", "SE", "Sergipe"],
  ["tocantins", "TO", "Tocantins"],
] as const;

const bySlug = new Map<string, { code: string; name: string }>(states.map(([slug, code, name]) => [slug, { code, name }]));
const byCode = new Map<string, { slug: string; name: string }>(states.map(([slug, code, name]) => [code, { slug, name }]));

export const brazilianStates = states.map(([slug, code, name]) => ({ slug, code, name }));

export function stateCodeFromPath(value: string): string | null {
  if (!value) return "";
  const normalized = value.toLowerCase();
  if (/^[a-z]{2}$/.test(normalized)) return byCode.has(normalized.toUpperCase()) ? normalized.toUpperCase() : null;
  return bySlug.get(normalized)?.code || null;
}

export function stateNameFromPath(value: string): string | null {
  const code = stateCodeFromPath(value);
  if (!code) return value ? null : "Brasil";
  return byCode.get(code)?.name || null;
}
